import React from 'react';

import { MenuItemType } from 'antd/lib/menu/interface';

import ShopDataModalAddEntry from './ShopDataModalAddEntry';
import AddIcon from '../../../common/Icons/AddIcon';

interface Props {
  label: string;
  options: MenuItemType[];
}

const ShopDataModalAddEntryPlus = ({ label, options }: Props) => {
  return (
    <ShopDataModalAddEntry
      label={label}
      options={options}
      content={
        <div
          style={{
            display: 'flex',
            gap: 6,
            lineHeight: 1,
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--text-primary)',
            fontSize: 12,
          }}
        >
          <AddIcon size={16} />
          <span style={{ marginRight: 5 }}>{label}</span>
        </div>
      }
    />
  );
};

export default ShopDataModalAddEntryPlus;
